import React from 'react'
import {
    Button,
    makeStyles,
} from '@material-ui/core'
import { clsx } from 'clsx';
import { Link } from 'react-router-dom';
import { useIsCreatorsPage } from '../../hooks/useIsCreatorsPage';

const linearGradient = "linear-gradient(90deg, #87959C 1.44%, #89959C 7.69%, #8B949B 13.94%, #B1B3BB 21.15%, #C3C8CC 31.25%, #F1F2F4 38.94%, #D2DBE6 51.44%, #D2DBE6 63.46%, #9AB0B7 81.73%, #A5B7C0 94.71%)"
const linearGradientHover = "linear-gradient(90deg, #606067, #A3A4A9, #D5D8E0, #767A7D )"
const linearGradientCreator = "linear-gradient(90deg, #CF819D, #FFB8D1, #CF819D)"
const linearGradientCreatorHover = "linear-gradient(90deg, #B86080, #F197B8, #FFB7D1, #B86080)"
const linearGradientBackground = "linear-gradient(90deg, #87959C, #89959B, #8B949B, #B1B3BB, #C3C8CC, #F1F2F4 40%, #D2DBE6, #D2DBE6, #9AB0B7, #A5B7C0 )"

const useStyles = makeStyles((theme) => ({
    outlinedButton: {
        border: " 1px solid transparent",
        color: '#ffffff',
        textTransform: 'none',
        fontSize: '16px',
        lineHeight: 1,
        padding: "16px 32px",
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    outlinedButtonPink: {
        borderImage: `${linearGradientCreator} 1`,
        "&:hover": {
            borderImage: `${linearGradientCreatorHover} 1`,
        },
    },
    outlinedButtonGray: {
        borderImage: `${linearGradient} 1`,
        "&:hover": {
            borderImage: `${linearGradientHover} 1`,
        },
    },
    containedButton: {
        textTransform: 'none',
        fontSize: '16px',
        lineHeight: 1,
        padding: "16px 32px",
        borderRadius: 0,
        backgroundPosition: "left center",
        transition: "all 0.3s ease",
        "& .MuiButton-label": {
            color: '#111111',
        },
        "&:hover": {
            backgroundPosition: "right center",
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    containedViewerButton: {
        background: linearGradientBackground,
        backgroundSize: "100% 100%",
        "&:hover": {
            backgroundSize: "120% 100%",
        },
    },
    containedCreatorButton: {
        background: linearGradientCreator,
        backgroundSize: "100% 100%",
        "&:hover": {
            backgroundSize: "150% 100%",
        },
    },
    containedPinkButton: {
        background: "linear-gradient(90deg, #CF819D, #FFB8D1, #CF819D)",
        backgroundPosition: "left",
        backgroundSize: "100% 100%",
        textTransform: 'none',
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: 1,
        padding: "16px 32px",
        borderRadius: 0,
        transition: "all 0.3s ease",
        "& .MuiButton-label": {
            color: '#111111',
        },
        "&:hover": {
            backgroundSize: "110% 100%",
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    outlinedPinkButton: {
        border: " 1px solid transparent",
        borderImage: `linear-gradient(90deg, #CF819D, #FFB8D1, #CF819D) 1`,
        color: '#ffffff',
        textTransform: 'none',
        fontSize: '16px',
        lineHeight: 1,
        padding: "16px 32px",
        "&:hover": {
            borderImage: `${linearGradientHover} 1`,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    }
}))

export const OutlinedButton = ({ text, to, styles, }: { text: string, to: string, styles?: string }) => {
    const classes = useStyles()
    const isCreatorsPage = useIsCreatorsPage();

    return (
        <Button
            variant="outlined"
            component={Link}
            to={to}
            className={clsx(classes.outlinedButton, isCreatorsPage ? classes.outlinedButtonPink : classes.outlinedButtonGray, styles)}
        >
            {text}
        </Button >
    )
}
export const ContainedButton = ({ text, styles }: { text: string, styles?: string }) => {
    const classes = useStyles()
    const isCreatorsPage = useIsCreatorsPage();

    return (
        <Button variant="contained"
            className={clsx(classes.containedButton,
                isCreatorsPage ? classes.containedCreatorButton : classes.containedViewerButton,
                styles)}>
            {text}
        </Button>
    )
}
export const ContainedPinkButton = ({ text, styles }: { text: string, styles?: string }) => {
    const classes = useStyles()

    return (
        <Button variant="contained" className={clsx(classes.containedPinkButton, styles)}>
            {text}
        </Button>
    )
}
export const OutlinedPinkButton = ({ text, styles }: { text: string, styles?: string }) => {
    const classes = useStyles()
    return (
        <Button variant="outlined" className={clsx(classes.outlinedPinkButton, styles)}>
            {text}
        </Button>
    )
}